import { Outlet } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
const Navbar = React.lazy(() => import('../components/Navbar'));
const Footer = React.lazy(() => import('../components/Footer'));
import { useAuthentication } from '../hooks/useAuthentication';
import { redirectToLogin } from '@/utils/redirect';
import { useHomeStore } from '@/pages/home/useHome';
import { classNames } from '@/utils/class-names';
import { loginTracker } from '@/services/auth/auth.service';
import { watchUserById } from '@/services/profile/profile.service';
import { trackUserData } from '@/lib/ga-custom-events/user';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function ProtectedLayout() {
  const result = useAuthentication();
  const [loadedMenu, setLoadedMenu] = useState(null);
  const [loadedFooter, setLoadedFooter] = useState(null);
  const [alreadyLogged, setAlreadyLogged] = useState(false);
  const { loadingPage } = useHomeStore();

  useEffect(() => {
    if (result?.authentication?.user) {
      trackUserData({
        id: result?.authentication?.user?.id?.toString(),
        user_id: result?.authentication?.user?.id?.toString(),
        user_name: result?.authentication?.user?.forename + ' ' + result?.authentication?.user?.surname || '-',
        school_id: result?.authentication?.user?.school?.id,
        school_name: result?.authentication?.user?.school?.name,
        role: result?.authentication?.user?.profile || '-',
      });

      if (alreadyLogged) return;

      loginTracker(result?.authentication?.user?.id);

      setAlreadyLogged(true);
    }
  }, [result?.authentication?.user, alreadyLogged]);

  useEffect(() => {
    if (!result?.authentication?.user?.id) {
      return;
    }

    const observable = watchUserById(`${result?.authentication?.user?.id}`);

    const subscription = observable?.subscribe({
      next: ({ data }) => {
        result.setAuthentication({
          ...result.authentication,
          user: {
            ...result?.authentication?.user,
            ...data?.usersPermissionsUser?.data?.attributes,
            ws_permission: data?.usersPermissionsUser?.data?.attributes?.ws_permission?.data?.attributes || null,
            school: {
              ...result.authentication?.user?.school,
              ...data?.usersPermissionsUser?.data?.attributes?.school?.data?.attributes,
              subscription: {
                ...data?.usersPermissionsUser?.data?.attributes?.school?.data?.attributes?.subscription?.data
                  ?.attributes,
              },
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          } as any,
        });
      },
      error: (error) => {
        if (
          error?.message === 'UNAUTHENTICATED' ||
          error?.message === 'Forbidden access' ||
          error?.message?.includes('401')
        ) {
          redirectToLogin();
        }
        console.log(error.message);
      },
    });

    return () => {
      subscription?.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result?.authentication?.user?.id]);

  if (!result?.authentication?.isAuthenticated) {
    redirectToLogin();
    return null;
  }

  return (
    <div className={classNames('wrapper duration-200', !loadingPage ? 'bg-page-gradient' : '')}>
      <Navbar setLoadedMenu={setLoadedMenu} />
      <div className="h-full min-h-screen">{loadedMenu && loadedFooter ? <Outlet /> : null}</div>
      <Footer setLoadedFooter={setLoadedFooter} />
    </div>
  );
}
